import React from 'react'
import Navbar from '../Navbar'
import { MDBContainer, MDBRow, MDBCol, MDBIcon, MDBBtn } from 'mdbreact'
import graphql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import FooterWhite from '../FooterWhite';
import { HashLink as Link } from 'react-router-hash-link';
import CategoryBlogs from './blog/CategoryBlogs';
import Loading from '../loaders/Loading';
import Error from '../loaders/Error';
import Lottie from 'lottie-react-web';
import pageConstruction from '../../img/page-construction.json';

const Search = ({match}) => {
    const { data, loading, error } = useQuery(graphql`
    query{
        blogs(limit:10, sort:"createdAt:desc", where: { title_contains: "${match.params.search}" }){
            id,
            title,
            content,
            createdAt
            description
            author{
                name
            }
            preview{
                url
                formats
            }
        }
    }
    `)
    if(loading) return <Loading/>
    if(error) return <Error/>

    return (
        <>
        <Navbar page="Search"/>
        <MDBContainer className="my-5 py-5">
            {match.params.search &&
            <section id="search-results" className="search-results-container pt-5 mt-5">
                <h1 className="font-weight-bold menu-mobile-style mb-4 display-4">
                    Search results for '{match.params.search}'
                </h1>
                <hr style={{ border: `1px solid #000` }} className="my-4" />
                <h6 className="h6-responsive font-weight-bold">
                    Showing {data.blogs.length === 1 ? `${data.blogs.length} result`: `${data.blogs.length} results`} 
                </h6>
                {data.blogs && data.blogs.length > 0 ? 
                <MDBRow className="pt-5 mt-5">
                    <MDBCol>
                        <CategoryBlogs selectedCategory={data.blogs}/>
                    </MDBCol>
                </MDBRow>
                :
                <>
                <div className="content text-center pb-4">
                    <MDBRow className="justify-content-center mt-n5">
                        <MDBCol md="5" lg="5">
                            <Lottie options={{ animationData: pageConstruction }}/>
                            <h4 className="h4-responsive mt-n4 font-weight-bold text-uppercase">
                                Oooops, there are no blogs by this '{match.params.search}' keyword
                            </h4>
                            <p className="h6-responsive">
                                Don't worry, you can <Link smooth className="link-underline" to="/search#search-blog">try again here</Link>.
                            </p>
                        </MDBCol>
                    </MDBRow>
                </div>
                </>
                }
            </section>}
        </MDBContainer>
        <MDBContainer fluid className="px-0 pt-5">
            <section className="p-5 grey lighten-4">
                <MDBRow className="py-5 justify-content-center">
                    <MDBCol md="10" lg="8">
                        <div className="text-center">
                            <h2 style={{ lineHeight: 1.5 }} className="h2-responsive font-weight-bold">Got Questions?</h2>
                            <p className="lead">Need more assistance? Don't worry we got your back! Give us a call between 10am - 7pm at +63 919 9239 29. We speak English, Tagalog and Cebuano. Just let us know what you need.</p>
                            <Link smooth to="/contact#contact-us">
                                <MDBBtn color="dark" className="text-capitalize">
                                    Send Message <MDBIcon fas icon="arrow-right ml-2"/>
                                </MDBBtn>
                            </Link>
                        </div>
                    </MDBCol>
                </MDBRow>
            </section>
        </MDBContainer>
        <FooterWhite/>
        </>
    )
}

export default Search
